import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { HelpText } from '../model/helpText.model';

@Injectable({
    providedIn: 'root'
})
export class HelpTextService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    index(): Observable<any> {
        return this.getMSINCatalog<any>(EndPoints.apiHelpTextIndex, undefined);
    }

    getHelpTexts(urlParam: string): Observable<any> {
        //console.log("help-text.service now running getHelpTexts()")
        //console.log("with urlParam:")
        //console.log(urlParam)
        return this.getMSINCatalog<any>(EndPoints.apiHelpText, {params:{ _: Date.now()}}, 'ids=' + urlParam);
    }

    createUpdate(helpText: HelpText): Observable<any> {
        return this.postMSINCatalog<any>(EndPoints.apiHelpText, false, null, helpText).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteHelpTexts(urlParam: string): Observable<any> {
        return this.deleteMSINCatalog<any>(EndPoints.apiHelpText, undefined, undefined, 'id=' + urlParam).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    tag(id: string, routeUrl?: string, routeController?: string, parentController?: string): Observable<any> {
        let queryParams = 'id=' + id;
        if (routeUrl) {
            queryParams += '&routeUrl=' + routeUrl;
        }
        if (routeController) {
            queryParams += '&routeController=' + routeController;
        }
        if (parentController) {
            queryParams += '&parentController=' + parentController;
        }
        return this.postMSINCatalog<any>(EndPoints.apiHelpTextTag, false, null, null, queryParams).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

	getBuildVersion(): Observable<any> {
        return this.getMSINCatalog<any>(EndPoints.apiBuildVersion, undefined);
    }
       
}
    
